module.exports = __webpack_public_path__ + "assets/greenCheckmark.ed7f1545.svg";